import {Box, HStack, useRadioGroup} from '@chakra-ui/react'
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {useTranslation} from 'next-i18next'
import {useRouter} from '_app/hooks/useRouter'
import {CategoryTree} from '_app/graphql/generated/graphql'
import {ListingNavigation} from '_app/types/listing'
import {CustomRadio} from '_app/components/CustomRadio/CustomRadio'

interface CategoriesMobileProps {
  navigation: ListingNavigation;
  category: CategoryTree;
}

const CategoriesMobile = ({ navigation, category }: CategoriesMobileProps) => {
  const { t } = useTranslation()
  const router = useRouter()
  const { locale } = router
  const menuItemsRef = useRef<HTMLDivElement>(null)
  const [value, setValue] = useState('')
  const navigationItems = useMemo(() => {
    const mainItem = {
      name: t('ALL'),
      url: navigation.mainUrl,
    }
    const items = (navigation.items || [])
      .filter(item => item?.include_in_menu !== 0)
      .map(item => ({
        name: item?.name,
        url: item?.url_path,
      }))
    return [mainItem, ...items]
  }, [navigation, category])
  const onChange = (value: string) => {
    setValue(value)
    onSubmit(value)
  }
  const { getRootProps, getRadioProps } = useRadioGroup({
    name: 'categories',
    value,
    onChange,
  })
  const onSubmit = (value: string) => window?.open(`/${locale}/${value}.html`, '_self')
  const group = getRootProps()
  useEffect(() => {
    const activeItem = navigationItems.find(item => item.url === value)?.name
    const menuItem = Array.from(menuItemsRef.current?.children || []).find(
      item => item.textContent === activeItem
    )
    const parentPaddingOffset = 30
    menuItemsRef.current?.parentElement?.scrollTo({
      left: (menuItem as HTMLElement)?.offsetLeft - parentPaddingOffset,
    })
  }, [value])
  useEffect(() => {
    const activeItem: any = navigationItems.find(item => item?.name === category?.name)
    setValue(activeItem?.url || navigationItems[0]?.url)
  }, [navigationItems, category?.name])
  return (
    <Box flex={1} mx={4} overflow="auto">
      <HStack
        alignItems="flex-start"
        spacing={4}
        {...group}
        css={{
          lineHeight: 2.75,

          label: {
            flexShrink: 0,
          },
        }}
        ref={menuItemsRef}
      >
        {navigationItems?.map(item => {
          return (
            <CustomRadio
              key={item.url}
              {...getRadioProps({
                value: item.url,
              })}
              checkedUnderline
            >
              {item.name}
            </CustomRadio>
          )
        })}
      </HStack>
    </Box>
  )
}

export default CategoriesMobile
